import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag, scrollToSection } from "@/components/Reveal";

const VERTICALS = [
  {
    title: "Hand-knotted, Handloom, Tufted Rugs & Machine-made Carpets",
    img: "/rugs-carpets.webp",
    span: "lg:col-span-7",
  },
  {
    title: "Bed, Bath & Table Linen",
    img: "/bed-bath-linen.webp",
    span: "lg:col-span-5",
  },
  {
    title: "Cushions, Throws & Curtains",
    img: "/cushions-curtains.webp",
    span: "lg:col-span-5",
  },
  {
    title: "Handicrafts & Décor Items",
    img: "/handicrafts-decor.webp",
    span: "lg:col-span-7",
  },
];

export const Products = () => (
  <section id="products" className="relative py-28 lg:py-40 bg-white" data-testid="products-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <SectionTag index="03" label="Product Portfolio" />
      </Reveal>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-20">
        <Reveal>
          <h2 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A1B33] max-w-2xl" data-testid="products-heading">
            Four categories. <span className="text-[#2E7FE0]">One accountable partner.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-[#54678A] max-w-md text-base leading-relaxed">
            Categories we source — from the cutting table to the container, every order passes
            through production, inspection, packing and dispatch under our supervision.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {VERTICALS.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.08} className={`${v.span} group`}>
            <button
              onClick={() => scrollToSection("#contact")}
              className="spotlight-frame relative block w-full text-left rounded-2xl border border-[#2E7FE0]/15 h-[440px] overflow-hidden"
              data-testid={`product-card-${i}`}
            >
              <img
                src={v.img}
                alt={v.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#051024] via-[#051024]/55 to-[#051024]/10 z-[3]" />
              <div className="absolute inset-x-0 bottom-0 z-[4] p-8 lg:p-10">
                <div className="flex items-start justify-between gap-4 mb-5">
                  <h3 className="font-display font-semibold text-2xl lg:text-3xl text-white leading-tight max-w-sm">
                    {v.title}
                  </h3>
                  <span className="shrink-0 w-11 h-11 rounded-full border border-[#2E7FE0]/50 flex items-center justify-center text-white transition-colors duration-300 group-hover:bg-[#2E7FE0]">
                    <ArrowUpRight className="w-5 h-5" />
                  </span>
                </div>

              </div>
              <span className="absolute top-6 left-8 z-[4] font-mono2 text-xs text-white/60">
                V/{String(i + 1).padStart(2, "0")}
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
